import type { HelpFile } from '../../types/help'
import { ProvisioningDashboardTestIds } from '../../../testids/ProvisioningDashboardTestIds'

export const provisioningDashboardHelp: HelpFile = {
  docPage: '/docs/provisioning/provisioning-history',
  texts: {
    [ProvisioningDashboardTestIds.provisioningDashboardPage]: 'Aktivität der Provisionierungs-Aufgaben — Anzahl wartender, laufender, abgeschlossener und fehlgeschlagener Aufgaben sowie Steuerungsaktionen.',
    [ProvisioningDashboardTestIds.btnArchiveCompleted]: 'Abgeschlossene Provisionierungs-Aufgaben archivieren, um die aktive Warteschlange schlank zu halten.',
    [ProvisioningDashboardTestIds.btnProcessAll]: 'Alle wartenden Provisionierungs-Aufgaben sofort ausführen — umgeht das geplante Zeitfenster.',
    [ProvisioningDashboardTestIds.btnRequeueReady]: 'Bereite, aber blockierte Aufgaben neu einreihen, damit sie im nächsten Worker-Zyklus abgeholt werden.',
    [ProvisioningDashboardTestIds.cardTitleAboutProvisioningTasks]: null,
    [ProvisioningDashboardTestIds.cardTitleStat]: null,
    [ProvisioningDashboardTestIds.statQueued]: 'Provisionierungs-Aufgaben in der Warteschlange.',
    [ProvisioningDashboardTestIds.statRunning]: 'Aktuell laufende Provisionierungs-Aufgaben.',
    [ProvisioningDashboardTestIds.statCompleted]: 'Erfolgreich abgeschlossene Provisionierungs-Aufgaben.',
    [ProvisioningDashboardTestIds.statFailed]: 'Provisionierungs-Aufgaben mit Fehler bei der Ausführung.',
  },
}
